// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"53":"webfontloader","207":"timeregistration","594":"about"}[chunkId] || chunkId) + "." + {"53":"9380816b","125":"2ef21eea","179":"993ec516","207":"c31f5dc2","330":"7c6442a1","594":"a57cede9"}[chunkId] + ".js";
};